import React, { Component } from "react"
import Dialog from "react-toolbox/lib/dialog"
import Division from "../../components/Division"
import * as strings from "../../strings"
import Yup from "../../lib/Yup"
import { Formik, Form } from "formik"
import _ from "lodash"
import styles from "./styles.css"
import * as FormikComponents from "../../components/FormikComponents"

const DEFAULT_AUTOMATIC_RATE = {
  startDate: new Date(),
  endDate: null,
  calculationType: "Fixed",
  value: 0.0,
}

const AUTOMATIC_RATE_SCHEMA = Yup.object().shape( {
  date: Yup.object().shape( {
    from: Yup.date()
      .required(),
    to: Yup.date()
      .nullable(),
  } ),
  value: Yup
    .number()
    .when( "calculationType", {
      is: "JusticeTax",
      then: fieldSchema => fieldSchema.nullable(),
      otherwise: fieldSchema => fieldSchema.required(),
    } )
    .required(),
  calculationType: Yup.string()
    .oneOf( _.keys( strings.AutomaticExpenseRuleCalculationTypeTranslation ) )
    .required(),
} )



class AutomaticExpenseRuleDialog extends Component {
  props: {
    onSubmit: ( mixed ) => any,
    onCancel: ( mixed ) => any,
    visible: boolean,
  }

  submit = ( values, formik ) => {
    this.props.onSubmit( {
      ...values,
      startDate: _.get( values, "date.from" ),
      endDate: _.get( values, "date.to" ),
      date: undefined,
      value: values.calculationType === "JusticeTax"
        ? null
        : parseFloat( values.value ),
    } )
    formik.resetForm()
  }

  cancel = formik => () => {
    this.props.onCancel( formik.values )
    formik.resetForm()
  }

  render () {
    const calculationTypes = _.chain( strings.AutomaticExpenseRuleCalculationTypeTranslation )
      .reduce( ( acc, val, key ) => ( [
        ...acc,
        { label: val, value: key },
      ] ), [] )
      .value()

    return (
      <Formik
        initialValues={DEFAULT_AUTOMATIC_RATE}
        validationSchema={AUTOMATIC_RATE_SCHEMA}
        onSubmit={this.submit}
        enableReinitialize
      >
        { ( formik ) => (
          <Dialog
            actions={[
              { label: strings.generalStrings.cancel, onClick: this.cancel( formik ) },
              { label: strings.generalStrings.keep, onClick: formik.submitForm },
            ]}
            active={this.props.visible}
            onEscKeyDown={this.cancel( formik )}
            onOverlayClick={this.cancel( formik )}
            type="small"
          >
            <Division title={strings.expenses.automaticExpenseRule} />
            <Form>
              <FormikComponents.DateRange
                label={strings.generalStrings.details}
                name="date"
              />
              <div className={styles.automaticExpenseRuleRow}>
                <FormikComponents.Dropdown
                  label={strings.management.expenseType}
                  name="calculationType"
                  source={calculationTypes}
                  auto={false}
                />
                <FormikComponents.Input
                  label={strings.generalStrings.value}
                  disabled={formik.values.calculationType === "JusticeTax"}
                  type="number"
                  step="0.01"
                  name="value"
                />
              </div>
            </Form>
          </Dialog>
        )}
      </Formik>
    )
  }
}

export default AutomaticExpenseRuleDialog



// WEBPACK FOOTER //
// ./src/views/ManageExpenseTypes/AutomaticExpenseRuleDialog.jsx